import { css } from '@emotion/react';
import memoize from 'fast-memoize';
export const createCSSSerializedStyles = (cssString) => {
    return css(cssString);
};
export const createCSSSerializedStylesWithMemo = memoize(createCSSSerializedStyles);
